module.exports = __webpack_public_path__ + "media/s3_v0.f1a0b70b.mp4";